
/**
 * Export `slykEndpoints`.
 */

export default {
  confirmEmail: '/widget/confirm-email',
  joinPayspaceBySms: '/widget/sms/join-payspace',
  payspace: '/widget/domains/${slug}',
  payspaceExists: '/widget/domains/${slug}/validate',
  recoverPassword: '/widget/forgot-password',
  resetPassword: '/widget/reset-password',
  signup: '/domains/signup',
  updateAccount: '/widget/users',
  uploadFile: '/widget/presign-url'
};
